import {ModalController} from '../common/modal.controller.js';


class GradController {
    constructor($uibModal, Grad) {
        this.$uibModal = $uibModal;
        this.ModelFactory = Grad;
        this.items = [];
        this.pager = {
            currentPage: 1,
            limit: 15,
            totalItems: 0,
            search: "",
        };

        this.refreshState();
    }

    refreshState(){
        this.getItems();
    }

    insert() {
        const model = {};
        const modal = this.$uibModal.open({
            template: '<grad-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></grad-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    edit(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<grad-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></grad-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    getItems() {
        const params = {
            limit: this.pager.limit,
            offset: 0,
            ordering: 'naziv',
            search: this.pager.search,
        };

        if (params.search === '') {
            delete (params.search);
        }

        params.offset = (this.pager.currentPage - 1) * params.limit;

        this.ModelFactory.findAll(params, {bypassCache: true}).then((response) => {
            this.items = response;
            if (angular.isDefined(response.meta)) {
                this.pager.totalItems = response.meta.count;
            }
        });
    }

    onFilter(value) {
        this.pager.search = value;
        this.refreshState();
    }

    pageChanged() {
        this.refreshState();
    }

}

GradController.$inject= ['$uibModal', 'Grad'];


export {GradController};



// WEBPACK FOOTER //
// ./app/components/grad/grad.controller.js